document.addEventListener('DOMContentLoaded', function() {
    // Nur auf der Homepage (index) ausführen
    if (!document.body.classList.contains('index')) {
        return;
    }

    // Funktion zum Scrollen des aktiven Slides
    function scrollToActiveSlide() {
        // Container und aktives Slide finden
        const container = document.querySelector('.jdgm-testimonials-container');
        const activeSlide = document.querySelector('.jdgm-card.jdgm-testimonial.jdgm-carousel-item.active');
        
        if (container && activeSlide) {
            // Position des aktiven Slides relativ zum Container berechnen
            const slideOffset = activeSlide.offsetLeft;
            
            // Smooth scroll zum aktiven Slide
            container.scrollTo({
                left: slideOffset,
                behavior: 'smooth'
            });
        }
    }

    // MutationObserver erstellen, um Änderungen der active-Klasse zu beobachten
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // Prüfen ob sich die Klasse geändert hat
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                
                // Prüfen ob das Element jetzt die active-Klasse hat
                if (target.classList.contains('active') && 
                    target.classList.contains('jdgm-card') && 
                    target.classList.contains('jdgm-testimonial')) {
                    scrollToActiveSlide();
                }
            }
        });
    });

    // Warte bis Judge.me geladen ist
    function initializeSliderObserver() {
        const testimonialContainer = document.querySelector('.jdgm-testimonials-container');
        
        if (testimonialContainer) {
            // Alle Testimonial Cards beobachten
            const testimonialCards = document.querySelectorAll('.jdgm-card.jdgm-testimonial.jdgm-carousel-item');
            
            testimonialCards.forEach(function(card) {
                observer.observe(card, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            });

            // Initial zum aktiven Slide scrollen
            setTimeout(scrollToActiveSlide, 100);
            
            // Event Listener für Window Resize hinzufügen
            window.addEventListener('resize', scrollToActiveSlide);
            
        } else {
            // Wenn Container noch nicht vorhanden, nochmal versuchen
            setTimeout(initializeSliderObserver, 500);
        }
    }

    // Initialisierung starten
    setTimeout(initializeSliderObserver, 1000);
});